import React from 'react';
import { useNavigate } from 'react-router-dom';
import LicenseActivation from '../components/LicenseActivation';

const Register = ({ onRegisterComplete }) => {
  const navigate = useNavigate();

  const handleActivationSuccess = () => {
    if (onRegisterComplete) {
      onRegisterComplete();
    }
    // Redirect to login after successful registration
    navigate('/login');
  };

  return <LicenseActivation onActivationSuccess={handleActivationSuccess} />;
};

export default Register;
